/**
 * Host bridge for Luau `Fill.image(...)`: encode RGBA → PNG and register a raster asset.
 */

import { createId } from "@/lib/ids";
import { registerRasterAssetBytes } from "./rasterAssets";
import { encodeRgbaToPng } from "./rgbaPng";

export interface ScriptImageMeta {
  name?: string | null;
  fillMode?: string | null;
  opacity?: number | null;
  mimeType?: string | null;
}

export function registerScriptImageFromRgba({
  width,
  height,
  rgba,
  metaJson,
}: {
  width: number;
  height: number;
  rgba: Uint8Array;
  metaJson?: string;
}): string {
  const w = Math.floor(width);
  const h = Math.floor(height);
  if (!Number.isFinite(w) || !Number.isFinite(h) || w < 1 || h < 1) {
    throw new Error(`invalid image size ${width}x${height}`);
  }

  let meta: ScriptImageMeta = {};
  if (metaJson) {
    try {
      meta = JSON.parse(metaJson) as ScriptImageMeta;
    } catch {
      meta = {};
    }
  }

  const png = encodeRgbaToPng(w, h, rgba);
  const assetId = createId("asset");
  registerRasterAssetBytes({
    id: assetId,
    bytes: png,
    name: typeof meta.name === "string" && meta.name.length > 0 ? meta.name : "Script Image",
    mimeType: "image/png",
  });
  return assetId;
}
